export enum RequestStatusEnum {
  REQUESTED = 'REQUESTED', REQUEST_SENT = 'REQUEST_SENT', REQUEST_READ = 'REQUEST_READ', CONSENT_GIVEN = 'CONSENT_GIVEN', CONSENT_REPORTED = 'CONSENT_REPORTED', REQUEST_DONE = 'REQUEST_DONE'
}
